import React from 'react';
import { AnalyticsContext } from '@backstage/core-plugin-api';
import { HighlightedSearchResultText } from '../HighlightedSearchResultText/HighlightedSearchResultText.esm.js';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { Link } from '@backstage/core-components';

const DefaultResultListItemComponent = ({
  result,
  highlight,
  icon,
  secondaryAction,
  lineClamp = 5
}) => {
  if (!result)
    return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, icon && /* @__PURE__ */ React.createElement(ListItemIcon, null, icon), /* @__PURE__ */ React.createElement(
    ListItemText,
    {
      primaryTypographyProps: { variant: "h6" },
      primary: /* @__PURE__ */ React.createElement(Link, { noTrack: true, to: result.location }, highlight?.fields.title ? /* @__PURE__ */ React.createElement(
        HighlightedSearchResultText,
        {
          text: highlight?.fields.title || "",
          preTag: highlight?.preTag || "",
          postTag: highlight?.postTag || ""
        }
      ) : result.title),
      secondary: /* @__PURE__ */ React.createElement(
        Typography,
        {
          component: "span",
          style: {
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: lineClamp,
            overflow: "hidden"
          },
          color: "textSecondary",
          variant: "body2"
        },
        highlight?.fields.text ? /* @__PURE__ */ React.createElement(
          HighlightedSearchResultText,
          {
            text: highlight.fields.text,
            preTag: highlight.preTag,
            postTag: highlight.postTag
          }
        ) : result.text
      )
    }
  ), secondaryAction && /* @__PURE__ */ React.createElement(Box, { alignItems: "flex-end" }, secondaryAction));
};
const HigherOrderDefaultResultListItem = (props) => {
  return /* @__PURE__ */ React.createElement(
    AnalyticsContext,
    {
      attributes: {
        pluginId: "search",
        extension: "DefaultResultListItem"
      }
    },
    /* @__PURE__ */ React.createElement(DefaultResultListItemComponent, { ...props })
  );
};

export { HigherOrderDefaultResultListItem as DefaultResultListItem, DefaultResultListItemComponent };
//# sourceMappingURL=DefaultResultListItem.esm.js.map
